import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface ICancelBackgroundJobParams {
  backgroundJobId: string;
  cancellationReason: string;
  notifyJobCreator: boolean;
  notifyProjectOwner: boolean;
  notifySiteAdministrators: boolean;
  notifyServerAdministrators: boolean;
}

export interface ICancelBackgroundJobResult extends IResult {
}

export class CancelBackgroundJobRequest extends Request<ICancelBackgroundJobParams, ICancelBackgroundJobResult> {
  constructor(params: ICancelBackgroundJobParams) {
    super('cancelBackgroundJob', params);
  }
}
